import type { IConsentState } from 'src/services/personal-data-protection/types';

export const UC_SERVICES = {
    Required: 'Abstract Essential DPS',
    Functional: 'Abstract Functional DPS',
    Advertising: 'Abstract Marketing DPS',
} as const;

export const UC_SERVICE_TO_CONSENT_CAT: { [key in (typeof UC_SERVICES)[keyof typeof UC_SERVICES]]: number } = {
    [UC_SERVICES.Required]: 1,
    [UC_SERVICES.Functional]: 2,
    [UC_SERVICES.Advertising]: 3,
} as const;

export const FALLBACK_CONSENT_STATE: IConsentState = {
    [UC_SERVICE_TO_CONSENT_CAT[UC_SERVICES.Required]]: true,
};
